module.exports = __webpack_public_path__ + "media/images/crypto/ripple_small-e9bdf1e6f35b2f75b56c2a3e1e909bd6.png";